var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.formGroupClass, 'form-group']},[(_vm.alias)?_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.alias)+":")]):_vm._e(),_c('vue-autonumeric',{ref:"input",class:[
      'form-control',
      'form-control-sm',
      'numeric',
      _vm.inputClass,
      { 'is-invalid': _vm.getError },
      { 'text-muted': _vm.shutoff },
    ],attrs:{"options":{
      decimalPlaces: _vm.decimalPlaces,
      digitGroupSeparator: '.',
      decimalCharacter: ',',
      currencySymbol: _vm.currencySymbol,
      currencySymbolPlacement: 's',
      defaultValueOverride: '1',
      emptyInputBehavior: _vm.emptyInputBehavior,
      maximumValue: _vm.maximumValue,
      minimumValue: _vm.minimumValue,
      modifyValueOnWheel: false,
    },"name":_vm.name,"disabled":_vm.isDisabled,"inputmode":"numeric"},on:{"input":_vm.onInput},nativeOn:{"blur":function($event){return _vm.onBlur.apply(null, arguments)},"keyup":function($event){return _vm.$emit('keyup', $event)}},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}}),(_vm.getError)?_c('div',{staticClass:"invalid-feedback invalid-feedback-overwrite"},[_vm._v("\n    "+_vm._s(_vm.getError)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }